import type { RouteRecordRaw } from "vue-router";

export const clientRoutes: RouteRecordRaw = {
    path: '/clients',
    children: [
        {
            name: 'Client Details',
            path: '/clients/:clientId',
            component: () => import('./client-details/ClientsDetails.vue'),
            children: [
                {
                    name: 'profile',
                    path: 'profile',
                    component: () => import('./client-details/profile/ClientsProfile.vue')
                },
                {
                    name: 'appointments',
                    path: 'appointments',
                    component: () => import('./client-details/appointments/ClientsAppointments.vue')
                },
                {
                    name: 'animals',
                    path: 'animals',
                    component: () => import('./client-details/animals/ClientsAnimals.vue')
                },
                {
                    name: 'payments',
                    path: 'payments',
                    component: () => import('./client-details/payments/ClientsPayments.vue')
                },
                {
                    name: 'communications',
                    path: 'communications',
                    component: () => import('./client-details/communications/ClientsCommunications.vue')
                },
                {
                    name: 'vcp',
                    path: 'vcp',
                    component: () => import('./client-details/vcp/ClientsVcp.vue')
                },
            ]
        },
        {
            name: 'Deposits',
            path: '/clients/deposits',
            component: () => import('./deposits/ClientsDeposits.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Add Deposit',
            path: '/clients/deposits/add',
            component: () => import('./deposits/ClientsDepositsAdd.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Idexx Results',
            path: '/clients/idexx',
            component: () => import('./idexx/IdexxResults.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Microchip Logs',
            path: '/clients/microchip-logs',
            component: () => import('./microchip-logs/MicrochipLogs.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Communication Logs',
            path: '/clients/communication-logs',
            component: () => import('./communication-logs/CommunicationLogs.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Search Clients / Animals',
            path: '/clients/search',
            component: () => import('./search/SearchPage.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Create Volume Client',
            path: '/clients/volume/create',
            component: () => import('./volume/ClientsCreateVolume.vue'),
        },
        {
            name: 'Volume Client Appointments',
            path: '/clients/volume/appointments',
            component: () => import('./volume/ClientsVolumeAppointments.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Merge Tool | Clients',
            path: '/clients/merge-clients',
            component: () => import('../merge/MergeClients.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Merge Tool | Animals',
            path: '/clients/merge-animals',
            component: () => import('../merge/MergeAnimals.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Merge Tool | Animals',
            path: '/clients/merge-animals',
            component: () => import('../merge/MergeAnimals.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Auditing Logs',
            path: '/clients/auditing-logs',
            component: () => import('../auditing/AuditingLogs.vue'),
            meta: { defaultLayout: true }
        },
    ]
}